import React from "react";
import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";
import { useLocation, useNavigate } from "react-router-dom";
import styles from "./DesignBoxConfirmationPreviewPage.module.css";

const DesignBoxConfirmedMsg = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { item } = state;
  return (
    <>
      <Header></Header>
      <div className={styles.confirmMsgContainer}>
        <h3>{item?.product?.product_category?.name}</h3>
        <p>
          デザイン確定しました。 お届けまで1ヶ月ほどお時間を頂戴します。
          お届けまで今しばらくお待ちくださいませ。
        </p>
        <button
          style={{ padding: "0 30px", width: "auto" }}
          className={styles.button2}
          onClick={() => {
            navigate("/design-box", { state: { tab: 3 } });
          }}
        >
          別の完成デザインを確認
        </button>
      </div>
      <Footer></Footer>
    </>
  );
};

export default DesignBoxConfirmedMsg;
